import { createContext, useContext, type JSX } from "solid-js"
import { type Cart, type OfferingType } from "../../features/payment/domain/models/offering-type"
import { createLocalStore } from "../helpers/create-local-store"

export class CartStore {
  constructor(public readonly cart: Cart = {}) {}
}

const [cartStore, setCartStore] = createLocalStore<CartStore>("cart", new CartStore())

const clearCart = (): void => {
  setCartStore(new CartStore())
}

const addProductToCart = (id: OfferingType, paddleId: string | null): void => {
  setCartStore(new CartStore({ ...cartStore().cart, [id]: paddleId }))
}

const getCart = (): Cart => {
  return { ...cartStore().cart }
}

export interface CartContextType {
  readonly cart: () => Cart
  readonly addProductToCart: (id: OfferingType, paddleId: string | null) => void
  readonly clearCart: () => void
}

const defaultUserContext: CartContextType = {
  cart: getCart,
  addProductToCart,
  clearCart,
}
const CartContext = createContext<CartContextType>(defaultUserContext)

export const CartProvider = (props: { children: JSX.Element }): JSX.Element => {
  return <CartContext.Provider value={defaultUserContext}>{props.children}</CartContext.Provider>
}

export const useCart = (): CartContextType => {
  return useContext(CartContext)
}
